<template>
  <div class='BotActions'>
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'BotActions'
}
</script>

<style scoped>
.BotActions {
  width: 96%;
  padding: 2%;
  display: flex;
  position: absolute;
  bottom: 0;
  border-top: thin solid #CCCCCC;
}
</style>
